export function capitalize(text: string): string {
  // If text is null, undefined, or empty, return it as is
  if (!text) return text;
  return text[0].toUpperCase() + text.slice(1);
}

export function isNullOrEmpty(message: string) {
  if (message === null || message.trim() === "") return true;
  return false;
}

export function camelCaseToNormal(text: string) {
  return text.replace(/([A-Z])/g, " $1");
}

export function snakeCaseToNormal(text: string) {
  return text.split("_").join(" ");
}
